import { CSSObject } from '@core-ui/react-stitch';

const getMenuStyles = (isBRRedesignEnabled: boolean) => (
  base: CSSObject,
): CSSObject => ({
  ...base,
  direction: 'rtl',
  right: 0,
  whiteSpace: 'nowrap',
  width: 'auto',
  ...isBRRedesignEnabled && { border: 'none' }
});

export default getMenuStyles;
